import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getClassByTagsLiveTraining = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.EVENTS.GET_CLASS_BY_TAG_LiveTraining,
    cancelToken
  );
};

export default getClassByTagsLiveTraining;
